<template>
  <div class="dft-d-container" :style="[container_Style]">
    <div class="dft-shelfasset_box" v-if="model == '1'" :style="[shelfasset_box_Style]">
      <div class="dft-shelfasset_item" :style="[shelfasset_item_style]">
        <div class="dft-shelfasset_image" :style="[shelfasset_image_style]">
          <!-- uniapp -->
          <el-image class="img_class" :src="userInfo.logo" fit="scale-down"></el-image>
        </div>
        <div class="dft-shelfasset_infobox">
          <div class="dft-shelfasset_info" :style="[{flex: 1,}]">
            <div class="dft-shelfasset_name">
              {{infoactive.name}}
              <div :style="[{'padding-left': '8px',},shelfasset_num_style]">{{infoactive.value}}</div>
            </div>
            <div class="dft-shelfasset_text">
              {{infoactive.info}}
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="dft-shelfasset_info">
            <div class="dft-shelfasset_scan">
              <!-- uniapp -->
              <i class="el-icon-full-screen"></i>
            </div>
            <div class="dft-shelfasset_scan_info">
              会员码
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dft-shelfasset_box" v-else-if="model == '2'" :style="[shelfasset_box_Style]">
      <div class="dft-shelfasset_item"  v-if="styletype == '1'" :style="[shelfasset_item_style]">
        <div class="dft-shelfasset_infobox">
          <div class="dft-shelfasset_info" :style="[{flex: 1,}]">
            <div class="dft-shelfasset_name">
              Hello
            </div>
            <div class="dft-shelfasset_text">
              善田江宁VIP尊贵会员
            </div>
          </div>
          <div class="dft-shelfasset_info">
            <div class="dft-shelfasset_image" :style="[shelfasset_image_style,{'margin-right': 0,}]">
              <!-- uniapp -->
              <el-image class="img_class" :src="userInfo.logo" fit="scale-down"></el-image>
            </div>
            <div class="dft-shelfasset_scan_info dft-scan_box">
              <div class="dft-shelfasset_scan" style="font-size: 11px;">
                <!-- uniapp -->
                <i class="el-icon-full-screen"></i>
              </div>
              会员码
            </div>
          </div>
        </div>
      </div>
      <div class="" v-else-if="styletype == '2'">
        <div class="dft-shelfasset_item" :style="[shelfasset_item_style]">
          <div class="dft-shelfasset_image" :style="[shelfasset_image_style]">
            <!-- uniapp -->
            <el-image class="img_class" :src="userInfo.logo" fit="scale-down"></el-image>
          </div>
          <div class="dft-shelfasset_infobox">
            <div class="dft-shelfasset_info" :style="[{flex: 1,}]">
              <div class="dft-shelfasset_name">
                {{userInfo.name}}
                <i class="el-icon-medal"></i>
              </div>
              <div class="dft-shelfasset_text">
                {{userInfo.viplevel}}专属会员
              </div>
            </div>
            <div class="dft-shelfasset_info">
              <div class="dft-shelfasset_scan">
                <!-- uniapp -->
                <i class="el-icon-full-screen"></i>
              </div>
              <div class="dft-shelfasset_scan_info">
                会员码
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dft-shelfasset_bottom" :style="[shelfasset_bottom_item_style,shelfasset_bottom_item_style_down]">
        <div class="dft-shelfasset_bottom_item" v-for="(item,index) in infolist.filter(item=>item.show == true)" :key="index">
          <div :style="[{'font-size': '18px','font-weight': 'bold',},shelfasset_num_style]">
            {{item.value}}
          </div>
          <div class="">
            {{item.name}}
          </div>
        </div>
      </div>

    </div>
    <div class="dft-shelfasset_box dft-shelfasset_box1" v-else-if="model == '3'" :style="[shelfasset_box_Style]">
      <div class="dft-shelfasset_item" :style="[{'flex': '1'},shelfasset_item_style]">
        <div class="dft-shelfasset_image" :style="[shelfasset_image_style]">
          <!-- uniapp -->
          <el-image class="img_class" :src="userInfo.logo" fit="scale-down"></el-image>
        </div>
        <div class="dft-shelfasset_infobox" :style="[{'align-items': 'center',}]">
          <div class="dft-shelfasset_info" :style="[{'flex-shrink': 0,'width': '80px',}]">
            <div class="dft-shelfasset_name" :style="[{'font-weight': 'bold',}]">
              {{userInfo.name}}
            </div>
            <div class="dft-shelfasset_text">
              {{userInfo.viplevel}}专属会员
            </div>
          </div>
        </div>
        <div class="dft-shelfasset_bottom" :style="[shelfasset_bottom_item_style,{'width':'100%'}]">
          <div class="dft-shelfasset_bottom_item" :style="[{'padding': '0 2px','font-size': '11px',}]" v-for="(item,index) in infolist.filter(item=>item.show == true)" :key="index">
            <div class="">
              {{item.name}}
            </div>
            <div :style="[{'font-size': '17px','font-weight': 'bold','margin-top': '4px'},shelfasset_num_style]">
              {{item.value}}
            </div>
            <div :style="[{'font-size':'10px','color':'#999'}]">
              {{item.info}}
            </div>
          </div>
        </div>
      </div>
      <div class="dft-right" :style="[{'margin-left': `${cardgap}px`}]">
        <div class="dft-right_p" :style="[{'margin-bottom': `${cardgap}px`}]">
          <div class="dft-right_top">
            <!-- uniapp -->
            <el-image class="img_class" :src="addimage[0].img" fit="scale-down">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
        </div>
        <div class="dft-right_p">
          <div class="dft-right_bottom">
            <!-- uniapp -->
            <el-image class="img_class" :src="addimage[1].img" fit="scale-down">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
        </div>
      </div>
    </div>
    <div class="dft-shelfasset_box" v-else-if="model == '4'" :style="[shelfasset_box_Style]">
      <div class="dft-shelfasset_item" :style="[shelfasset_item_style]">
        <div class="dft-shelfasset_image" :style="[shelfasset_image_style]">
          <!-- uniapp -->
          <el-image class="img_class" :src="userInfo.logo" fit="scale-down"></el-image>
        </div>
        <div class="dft-shelfasset_infobox" :style="[{'align-items': 'center',}]">
          <div class="dft-shelfasset_info" :style="[{'flex-shrink': 0,'width': '80px',}]">
            <div class="dft-shelfasset_name" :style="[{'font-weight': 'bold',}]">
              {{userInfo.name}}
            </div>
            <div class="dft-shelfasset_text">
              {{userInfo.viplevel}}专属会员
            </div>
          </div>
          <div class="dft-shelfasset_bottom" :style="[shelfasset_bottom_item_style]">
            <div class="dft-shelfasset_bottom_item" :style="[{'padding': '0 12px','font-size': '11px',}]" v-for="(item,index) in infolist.filter(item=>item.show == true)" :key="index">
              <div class="">
                {{item.name}}
              </div>
              <div :style="[{'font-size': '17px','font-weight': 'bold','margin-top': '4px'},shelfasset_num_style]">
                {{item.value}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  props: {
    compData: {
        type: [Array,Object],
        default: ()=>[]
    },
  },
		options: {
			styleIsolation: 'shared', // 解除样式隔离
		},
  data () {
    return {
      showDialog: false,
    };
  },
  watch:{
    compData: {
      handler: function(newVal){
        if(newVal){
          this.$nextTick(() => {
            // console.log('comp--D-ata--0',newVal)
          });
        }
      },
      deep: true,
      immediate: true,
    }
  },
  computed: {
    //数据
    userInfo(){
      return this.compData?.attr?.a1?.value
    },
    model(){
      return this.compData?.attr?.a2?.value
    },
    styletype(){
      return this.compData?.attr?.a3?.value
    },
    infolist(){
      return this.compData?.attr?.a4?.value
    },
    infolistNum(){
      return this.compData?.attr?.a4?.value.filter(item=>item.show == true).length || 0
    },
    infoactive(){
      return this.compData?.attr?.a4?.value[this.compData?.attr?.a4?.activeIndex]
    },
    cardstyle(){
      return this.compData?.attr?.a5?.value
    },
    texticoncolor(){
      return this.compData?.attr?.a7?.value
    },
    cardtype(){
      return this.compData?.attr?.a9?.value
    },
    cardgap(){
      return this.compData?.attr?.a14?.value
    },
    addimage(){
      return this.compData?.attr?.a15?.value
    },
    // 样式
    container_Style(){
      return {
        'padding': `4px ${this.compData?.attr?.['a13']?.value}px`,
        'background': this.compData?.attr?.['a8']?.value,
      }
    },
    shelfasset_box_Style(){
      return {
        'color': this.compData?.attr?.['a7']?.value,
        'border-radius': this.compData?.attr?.['a12']?.value,
        'box-shadow': this.cardstyle=='2'?'0 2px 12px rgba(100, 101, 102, .12)':'unset',
        'border': this.cardstyle=='3'?'1px solid #ebedf0':'none',
      }
    },
    shelfasset_item_style(){
      switch(this.cardtype){
        case '1':
          return {
            'background-image': `url(${this.compData?.attr?.['a10']?.value})`,
            'background-size': '100% 100%',
            'background-repeat': 'no-repeat',
            'flex-direction': this.model == '3'?'column':'unset',
          }
        case '2':
          return {
            'background': this.cardstyle=='4'?'transparent':this.compData?.attr?.['a11']?.value,
            'flex-direction': this.model == '3'?'column':'unset',
          }
        default:
          return {}
          
      }
    },
    shelfasset_image_style(){
      switch (this.model) {
        case '2':
          return {
            'width': '48px',
            'height': '48px',
          }
        case '4':
          return {
            'width': '42px',
            'height': '42px',
          }
        default:
          return {}
      }
    },
    shelfasset_text_style(){
      return {
        // 'font-size': `${this.compData?.attr?.['a9']?.value}px`,
      }
    },
    shelfasset_num_style(){
      return {
        'color': this.compData?.attr?.['a6']?.value,
      }
    },
    shelfasset_bottom_item_style(){
      return {
        'grid-template-columns': `repeat(${this.infolistNum}, 1fr)`
      }
    },
    shelfasset_bottom_item_style_down(){
      return {
        'background': this.cardstyle=='4'?'transparent':this.compData?.attr?.['a11']?.value,
        'padding': '10px 0',
      }
    },
  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
    })
  },

  methods: {
    initData(){
    },
  },
};
</script>

<style lang="scss" scoped>
.dft-d-container{
  width: 100%;
  height: auto;
  padding: 0;
  box-sizing: border-box;
}
.dft-shelfasset_box{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  font-size: 13px;
  &::-webkit-scrollbar {
    height: 0px;
  }
}
.dft-shelfasset_box1{
  display: flex;
  .dft-shelfasset_image{
    margin: 0;
  }
  .dft-shelfasset_name,.dft-shelfasset_text{
    justify-content: center;
    text-align: center;
  }
}
.dft-shelfasset_item{
  box-sizing: border-box;
  display: flex;
  align-items: center;
  position: relative;
  padding: 10px;
}
.dft-shelfasset_image{
  width: 60px;
  height: 60px;
  border-radius: 50%;
  flex-shrink: 0;
  overflow: hidden;
  margin-right: 10px;
}
.dft-shelfasset_infobox{
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.dft-shelfasset_info{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.dft-shelfasset_name{
  display: flex;
  align-items: center;
  text-align: left;
  width: 100%;
  height: 24px;
  font-size: 15px;
  line-height: 24px;
}
.dft-shelfasset_text{
  display: flex;
  display: -webkit-box;
  justify-content: center;
  align-items: center;
  text-align: left;
  font-size: 12px;
  width: 100%;
  height: 20px;
  line-height: 20px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.dft-scan_box{
  font-size: 11px;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 4px 12px;
  margin-top: 5px;
  border-radius: 10px;
  box-sizing: border-box;
  background: #ff3333;
  text-align: center;
  color: #fff;
}
.dft-shelfasset_scan{
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  box-sizing: border-box;
}
.dft-shelfasset_scan_info{
  font-size: 12px;
}
.dft-shelfasset_bottom{
  display: grid;
  .dft-shelfasset_bottom_item{
    padding: 0 16px;
    margin: 12px 0 6px;
    box-sizing: border-box;
    border-left: 1px solid #ddd;
    display: flex;
    flex-direction: column;
    align-items: center;
    &:first-of-type{
      border-left: none;
    }
  }
}
.img_class{
  display: block;
  width: 100%;
  height: 100%;
}
/deep/.image-slot{
  width: 100%;
  height: 100%;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dft-right{
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  .dft-right_p{
    width: 100%;
    height: 50%;
    box-sizing: border-box;
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
  }
  .dft-right_top{
    width: 100px;
    height: 100px;
  }
  .dft-right_bottom{
    width: 100px;
    height: 100px;
  }
}
</style>

